
import './registrationLeadScrutiny.css'
import usericon from '../../../images/user-icon.png'
import { useNavigate } from "react-router-dom";
import apiClient from '../../../axios';
import jwt from 'jwt-decode';
import { GET_MAPPING_DETAILS, GET_USER_DETAILS, GET_ALL_STAKEHOLDERS, STAKEHOLDER_COUNT } from '../../../common/URLs';
import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import ScrutinyDetails from '../Registration-Incharge/scrutinyDetails';
import { PROD } from "../../../common/constants";
import { getUserDetails } from '../../../common/Utils';

function RegistrationLeadScrutiny() {
  const [emailId, setEmailId] = useState(localStorage.getItem('InspectorEmail'));
  const [userId, setUserId] = useState(localStorage.getItem('uuid'));
  const [role, setRole] = useState(localStorage.getItem('role'));
  const [userDetails, setUserDetails] = useState();
  const [mappingDetails, setMappingDetails] = useState();

  useEffect(() => {
    getUserDetails(emailId, updateUserDetails);
  }, []);

  const updateUserDetails = (response) => {
    setUserDetails(response);
  }
  function viewAllAssignedStakeholders(e, resourceUpdate) {
    e.preventDefault();
    navigate("/registrationHome/dashboard/viewAllAssignedStakeholders", { state: { userid: userId, isResourceUpdate: resourceUpdate } });
  }
  function viewAllClarifications(e, resourceUpdate) {
    e.preventDefault();
    navigate("/registrationHome/dashboard/viewAllClarifications", { state: { userid: userId, isResourceUpdate: resourceUpdate } });
  }
  function viewAllApplicationsScrutiny(e) {
    e.preventDefault();
    navigate("/registrationHome/dashboard/viewAllApplications", { state: { userid: userId } });
  }

  function onVerifyClick(e) {
    e.preventDefault();
    navigate("/registrationHome/dashboard/verifyStakeholderDocuments");
  }

  const navigate = useNavigate();
  const location = useLocation();

  const pendingAppCount = userDetails?.applicationStatusCount?.[0]?.count;
  const pendingClarificationsCount = userDetails?.applicationStatusCount?.[1]?.count;
  const pendingTotalAppCount = userDetails?.applicationStatusCount?.[2]?.count;
  const pendingResourceUpdate = userDetails?.applicationStatusCount?.[3]?.count;
  const pendinfResourceUpdateClarification = userDetails?.applicationStatusCount?.[4]?.count;
  const mappingArray = mappingDetails?.scrutinizermappings;

  return (
    <div>
      <Container fluid>
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG62</p>}


        <Row>
          <Col xs={12} md={12}>
            <p className='lead_header_text'>OVERVIEW</p>
          </Col>
        </Row>
        <Row>
          {/* <Col xs={6} md={4}>
                        <div className='lead_card'>
                            <a href='' onClick={(e) => viewAllApplicationsScrutiny(e)} style={{ color: '#005BAA', float: 'right', marginTop: '0vh'}}>View all </a>
                            <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingTotalAppCount}</Typography>
                            <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Applications received from SCM App</Typography>
                      </div></Col> */}
          <Col xs={6} md={4}>
            <div className='lead_card'>
              <a href='' onClick={(e) => viewAllAssignedStakeholders(e, '')} style={{ color: '#005BAA', float: 'right', marginTop: '0vh' }}>View all </a>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingAppCount}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Applications for Review after Scrutiny</Typography>
            </div></Col>
          {/* <Col xs={6} md={4}>
                        <div className='lead_card'>
                            <a href='' onClick={(e) => viewAllClarifications(e)} style={{ color: '#005BAA', float: 'right', marginTop: '0vh'}}>View all </a>
                            <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingClarificationsCount}</Typography>
                            <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Applications for Clarification from Registration Incharge</Typography>
        </div></Col> */}
          <Col xs={6} md={4}>
            <div className="onboarded-card">
              <a href='#' onClick={(e) => onVerifyClick(e)} style={{ color: '#005BAA', marginLeft: '16vw', marginTop: '0vh', position: 'absolute' }}>Verify </a>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>
                &nbsp;
              </Typography>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>
                &nbsp;
              </Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Stakeholder Documents Verification</Typography>
            </div>
          </Col>
          <Col xs={6} md={4}>
            <div className='lead_card'>
              <a href='' onClick={(e) => viewAllAssignedStakeholders(e, 'ResourceUpdate')} style={{ color: '#005BAA', float: 'right', marginTop: '0vh' }}>View all </a>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingResourceUpdate}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Applications for Resource Update</Typography>
            </div></Col>
          <Col xs={6} md={4}>
            <div className='lead_card'>
              <a href='' onClick={(e) => viewAllClarifications(e, 'ResourceUpdate')} style={{ color: '#005BAA', float: 'right', marginTop: '0vh' }}>View all </a>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendinfResourceUpdateClarification}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Applications for Resource Update Clarification</Typography>
            </div></Col>
        </Row>
        <Row>
          <ScrutinyDetails userid={userId} role={role} />
        </Row>
      </Container>
    </div>
  )
}

export default RegistrationLeadScrutiny;
